<template>
  <div>
    <v-col>
      <v-autocomplete
        :label="label"
        :prepend-icon="icon"
        :items="theProdutos"
        :multiple="multiple"
        item-text="descricao"
        return-object
        @click="selectAllProducts"
        @input="$emit('input', $event)"
        @change="$emit('change', $event)"
      ></v-autocomplete>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: 'RelatorioCargaDescargaListFiltroModalItemInputProduto',
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    rules: {
      type: [Object, String],
    },
    fornecedor: {
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectProdutos: [],
    }
  },
  computed: {
    ...mapState('produtos', ['produtos']),
    ...mapState('auth', ['user', 'empresaAtual', 'perfilAtual']),
    theProdutos() {
      if (this.value) {
        if (this.multiple) {
          return [...this.value].concat(
            this.selectProdutos.filter(
              (c) => !this.value.some((v) => v.id === c.id)
            )
          )
        }
        return [this.value].concat(
          this.selectProdutos.filter((c) => this.value.id != c.id)
        )
      }
      return this.selectProdutos
    },
  },
  methods: {
    ...mapActions('template', [
      'successMessage',
      'errorMessage',
      'setDialogMessage',
    ]),
    ...mapMutations('produtos', ['setProduto']),
    async selectAllProducts() {
      if (this.fornecedor.public_id != null) {
        this.setProduto(this.fornecedor.produtos)
        this.selectProdutos = [...this.produtos]
      } else {
        this.selectProduto = [{ descricao: 'Nenhum', id: null }]
      }
    },
  },
  async created() {},
}
</script>
